export const WINDOW_RESIZE = 'WINDOW_RESIZE'
export const TOGGLE_SELECT_JOURNEY = 'TOGGLE_SELECT_JOURNEY'
export const TIMER_TICK = 'TIMER_TICK'
export const RESET_INACTIVITY_TIMER = 'RESET_INACTIVITY_TIMER'
export const TOGGLE_IDLE_WARNING = 'TOGGLE_IDLE_WARNING'


// WEBPACK FOOTER //
// ./src/constants/util-constants.js